import { LoadingOutlined } from "@ant-design/icons";

const PivotLoading = () => {
  return (
    <>
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <LoadingOutlined style={{ fontSize: "80px", color: "#a3a3a3" }} />
        </div>
      </div>
    </>
  );
};

export default PivotLoading;
